import placeholder from "url:asset/song-placeholder.svg";
import TileFrame from "./TileFrame";

// Web port of SongTileView + SongTileButton
// (LibraryFeature/View/Component/Songs/).
//
// In the app, tapping a song opens its streaming platforms.

export interface SongTileProps {
  title: string;
  artistName: string;
  artworkUrl: string | null;
  /** Fixed edge length, or null to fill the available width. */
  width: number | null;
  onClick: () => void;
}

export default function SongTile(props: SongTileProps) {
  return <TileFrame
    width={props.width}
    title={props.title}
    subtitle={props.artistName}
    onClick={props.onClick}
  >
    <img
      src={props.artworkUrl ?? placeholder}
      alt=""
      className="h-full w-full object-cover"
    />
  </TileFrame>
}
